import { Button, Col, Row } from 'react-bootstrap';
import TextEditor from './text-editor';
import { cmsString } from '../../../utils/string';
import { useEffect, useState } from 'react';
import APICallService from '../../../api/apiCallService';
import { CSM_PAGE } from '../../../api/apiEndPoints';
import { success } from '../../../Global/toast';
import { cmsToast } from '../../../utils/toast';
import Loader from '../../../Global/loader';
const AboutUs = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [postData, setPostData] = useState<any>('');
  useEffect(() => {
    (async () => {
      setFetchLoading(true);
      await fetchPolicyData();
      setFetchLoading(false);
    })();
  }, []);
  const fetchPolicyData = async () => {
    setLoading(true);
    let apiService = new APICallService(CSM_PAGE.GET_ABOUT_US);
    let response: any = await apiService.callAPI();
    if (response) {
      setData(response);
    }
    setLoading(false);
  };
  const saveAboutUs = async () => {
    setLoading(true);
    let apiService = new APICallService(CSM_PAGE.POST_ABOUT_US, {
      content: postData,
    });
    let response: any = await apiService.callAPI();
    if (response) {
      success(cmsToast.updateAboutUs);
      setData(response);
    }
    setLoading(false);
  };
  return (
    <>
      <Row className="align-items-center">
        <Col
          md
          className="align-self-center mb-5"
        >
          <h1 className="fs-22 fw-bolder">{cmsString.aboutUsTitle}</h1>
        </Col>
        {/* <>{console.log(setData)}</> */}
        {fetchLoading ? (
          <div className="d-flex justify-content-center m-4">
            <Loader loading={fetchLoading} />
          </div>
        ) : (
          <>
            <TextEditor
              data={data}
              setData={setData}
              onChange={(val: any) => {
                setPostData(val);
              }}
            />
            <Col
              xs="auto"
              className="pt-7"
            >
              <Button
                variant="primary"
                size="lg"
                onClick={saveAboutUs}
                disabled={loading}
              >
                {!loading && (
                  <span className="indicator-label fs-16 fw-bolder">
                    {cmsString.save}
                  </span>
                )}
                {loading && (
                  <span
                    className="indicator-progress fs-16 fw-bolder"
                    style={{ display: 'block' }}
                  >
                    Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </Button>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};
export default AboutUs;
